import styled, { css, keyframes } from 'styled-components';

interface IGProps {
  type?: string;
  isFocused: any;
  isFilled: boolean;
  hasValueInProps: boolean;
  hasError: boolean;
  isDisabled?: any;
  loading?: any;
}

interface IGProps2 {
  disableMargin?: boolean;
}

interface ErrorMessageProps {
  hasError: boolean;
  isHovered: boolean;
}

const shake = keyframes`
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
`;

export const InputContainer = styled.div<IGProps2>`
  display: block;
  margin: 1rem 0rem;

  label {
    display: block;
    width: 100%;
    min-height: 16px;
    font-size: 14px;
    color: rgb(135, 134, 139);
    margin-bottom: 8px;
    pointer-events: none;
    user-select: none;
  }

  > div {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    background: #fff;
  }
  ${props => 
  props.disableMargin && css`
    margin: 0;
  `}
`;

export const InputGroup = styled.div<IGProps>`
  position: relative;
  flex: 1 1 0%;
  border: 1px solid;
  border-color: #c4c4c4;
  border-radius: 0.2rem;
  transition: 0.3s ease-in;

  ${props =>
    props.hasError &&
    css`
      animation: ${shake} 0.82s ease-out;
    `}

  ${props =>
    props.isDisabled ||
    (props.loading &&
      css`
        border-color: hsl(0, 0%, 90%);

        &::placeholder {
          color: hsl(0, 0%, 50%);
        }
      `)}

  input[type="date"] {
    color: #555;
    font-size: 15px;
    font-family: ${props => props.theme.fontDefault};
  }

  input {
    width: 100%;
    height: 48px;
    font-size: 16px;
    background: #fff;
    color: ${props => props.theme.textColor};
    padding: 0px 1em;
    border-radius: 5px;

    &:disabled {
      background-color: hsl(0, 0%, 95%);
      font-size: 14px;

      &::placeholder {
        color: hsl(0, 0%, 50%);
      }
    }
  }

  ${props =>
    props.isFocused &&
    css`
      border-color: ${props => props.theme.primaryColor};

      > button > svg {
        color: ${props => props.theme.primaryColor};
      }
    `}

  ${props =>
    props.hasError &&
    css`
      border-color: ${props => props.theme.error};
    `}
`;

export const ToggleView = styled.button`
  background: transparent;
  border: 0;
  width: 24px;
  height: 24px;
  margin-right: 1rem;

  svg {
    transition: all 0.3s ease-in-out;
    color: #c4c4c4;
  }
`;

export const ErrorMessage = styled.div<ErrorMessageProps>`
  position: relative;
  display: block;
  height: fit-content !important;
  background: transparent !important;
  margin-top: 0.4rem;
  transition: 0.3s ease-in-out;

  div {
    display: block;
    color: ${props => props.theme.error};
    font-style: italic;
    font-size: 0.75rem;
    text-transform: normal;
    pointer-events: none;
    user-select: none;
  }
`;
